module.exports = __webpack_public_path__ + "img/Melon-temporada.e712c214.jpg";